import type { ResourceType } from '../types/resources'

// 🚨 Mirrors ``backend/shared/resource_catalog.py`` ``url_template`` per
// resource type. Backend is the source of truth - the API response
// already exposes a fully-built ``url`` field on ``FranchisePartnerResource``.
// We re-derive locally only for the optimistic edit case in
// ``FpResourcesTable``: the user types a new ID and the open/copy icons
// need an immediately usable URL before the row is saved. Adding a new
// ``ResourceType`` here without also updating the backend catalog (or
// vice-versa) breaks the round-trip.
const RESOURCE_URL_TEMPLATES: Record<ResourceType, string | null> = {
  google_sheet: 'https://docs.google.com/spreadsheets/d/{id}/edit',
  gdrive_folder: 'https://drive.google.com/drive/folders/{id}',
  url: null,
}

export const buildResourceUrl = (
  resourceType: ResourceType,
  resourceId: string | null,
): string | null => {
  if (!resourceId) return null
  const template = RESOURCE_URL_TEMPLATES[resourceType]
  if (!template) return null
  return template.replace('{id}', resourceId)
}
